/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Settings_Rest_SoundInputs */

const en_us2_workout_logging_settings_rest_sound = /** @type {(inputs: Workout_Logging_Settings_Rest_SoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest-over sound`)
};

const pt_br2_workout_logging_settings_rest_sound = /** @type {(inputs: Workout_Logging_Settings_Rest_SoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Som do fim do descanso`)
};

const es_419_workout_logging_settings_rest_sound = /** @type {(inputs: Workout_Logging_Settings_Rest_SoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonido de fin del descanso`)
};

const pt_pt2_workout_logging_settings_rest_sound = /** @type {(inputs: Workout_Logging_Settings_Rest_SoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Som do fim do descanso`)
};

const fr_fr2_workout_logging_settings_rest_sound = /** @type {(inputs: Workout_Logging_Settings_Rest_SoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son de fin de repos`)
};

const de_de2_workout_logging_settings_rest_sound = /** @type {(inputs: Workout_Logging_Settings_Rest_SoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton bei Pausenende`)
};

const it_it2_workout_logging_settings_rest_sound = /** @type {(inputs: Workout_Logging_Settings_Rest_SoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suono di fine recupero`)
};

/**
* | output |
* | --- |
* | "Rest-over sound" |
*
* @param {Workout_Logging_Settings_Rest_SoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_settings_rest_sound = /** @type {((inputs?: Workout_Logging_Settings_Rest_SoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Settings_Rest_SoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_settings_rest_sound(inputs)
	if (locale === "es-419") return es_419_workout_logging_settings_rest_sound(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_settings_rest_sound(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_settings_rest_sound(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_settings_rest_sound(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_settings_rest_sound(inputs)
	return en_us2_workout_logging_settings_rest_sound(inputs)
});
export { workout_logging_settings_rest_sound as "workout-logging.settings_rest_sound" }